import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './KaiCoachBuilderSection.module.css';

export function KaiCoachBuilderSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-builder-title"
      background="white"
      data-testid="kai-coach-section-builder"
    >
      <div className={styles.card}>
        <span aria-hidden="true" className={styles.avatar}>
          EL
        </span>
        <div className={styles.copy}>
          <p className={styles.kicker}>Designed and built by an educator</p>
          <h2 className={styles.name} id="kai-coach-builder-title">
            Elizabeth Landers
          </h2>
          <p className={styles.roles}>
            Chief AI Architect, Kudu Humanities <span aria-hidden="true">·</span> UCLA Humanities
          </p>
          <p className={styles.body}>
            Every Kai Coach module is designed against the ways a previous cohort’s writing actually
            went wrong, not a general theory of what students get wrong. That is why a new module
            begins by reading the course’s own student writing.
          </p>
          <p className={styles.body}>Selected as a 2025 ASU+GSV AI Innovator.</p>
        </div>
      </div>
    </SectionWrapper>
  );
}
